import React from 'react';

/**
 * PageContainer - Reusable page container component
 * Follows React Rules: Pure component, idempotent
 * 
 * @param {ReactNode} children - Page content
 * @param {string} className - Additional CSS classes
 */
const PageContainer = ({ children, className = '' }) => {
  return (
    <div className={`li-main-blog-page pt-60 pb-60 ${className}`}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageContainer;

